import React from 'react';
import './FeatureGrid.css';

/**
 * FeatureGrid Component
 * Grid layout for displaying features with icons
 * 
 * @param {Array} features - Array of {icon: ReactNode, title: string, description: string}
 * @param {string} className - Additional CSS classes
 */
const FeatureGrid = ({ features = [], className = '' }) => {
  return (
    <div className={`feature-grid ${className}`}>
      {features.map((feature, index) => (
        <div key={index} className="feature-item">
          {feature.icon && (
            <div className="feature-icon">{feature.icon}</div>
          )}
          <div className="feature-content">
            <h4>{feature.title}</h4>
            <p>{feature.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureGrid;























